module.exports = __webpack_public_path__ + "static/media/feedback.e99544c8.svg";